export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function isValidZipCode(zip: string): boolean {
  return /^\d{5}(-\d{4})?$/.test(zip);
}

interface DateFieldError {
  message: string;
  field: string;
}

const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const MIN_YEAR = 1900;

function localTodayStr(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function isRealCalendarDate(dateStr: string): boolean {
  const match = dateStr.match(DATE_PATTERN);
  if (!match) return false;
  const [, y, m, d] = match;
  const date = new Date(Number(y), Number(m) - 1, Number(d));
  return (
    date.getFullYear() === Number(y) &&
    date.getMonth() === Number(m) - 1 &&
    date.getDate() === Number(d)
  );
}

function yearOf(dateStr: string): number {
  return Number(dateStr.slice(0, 4));
}

export function validateDecedentDates(
  dob: string | undefined,
  dod: string | undefined,
  dobField: string,
  dodField: string,
): DateFieldError | null {
  const today = localTodayStr();

  if (!dob) {
    return { message: "Date of birth is required", field: dobField };
  }
  if (!isRealCalendarDate(dob)) {
    return { message: "Please enter a valid date of birth", field: dobField };
  }
  if (yearOf(dob) <= MIN_YEAR) {
    return { message: `Date of birth must be after ${MIN_YEAR}`, field: dobField };
  }
  if (dob > today) {
    return { message: "Date of birth cannot be in the future", field: dobField };
  }

  if (!dod) {
    return { message: "Date of passing is required", field: dodField };
  }
  if (!isRealCalendarDate(dod)) {
    return { message: "Please enter a valid date of passing", field: dodField };
  }
  if (yearOf(dod) <= MIN_YEAR) {
    return { message: `Date of passing must be after ${MIN_YEAR}`, field: dodField };
  }
  if (dod > today) {
    return { message: "Date of passing cannot be in the future", field: dodField };
  }
  if (dod <= dob) {
    return { message: "Date of passing must be after date of birth", field: dodField };
  }

  return null;
}

export function validateInviteForm(
  fullName: string,
  email: string,
): { fullName?: string; email?: string } {
  const errors: { fullName?: string; email?: string } = {};
  if (!fullName.trim()) errors.fullName = "Full name is required";
  if (!email.trim()) {
    errors.email = "Email is required";
  } else if (!isValidEmail(email)) {
    errors.email = "Please enter a valid email";
  }
  return errors;
}
